import React from "react";
import {
	Avatar,
	Button,
	Input,
	Select,
	SelectItem,
	Card,
	CardBody,
} from "@heroui/react";
import axios from "axios";

function FavPage(props) {
	const [uid, setUid] = React.useState(
		() => URL.parse(location.href).searchParams?.get("uid") || "",
	);
	const [favList, setFavList] = React.useState([]);
	const [items, setItems] = React.useState([]);
	const [selectedKey, setSelectedKey] = React.useState(new Set());

	const itemsRef = React.createRef([]);

	const fetchItemsByFid = async (fid, id) => {
		const res = await axios.get("/api/bilibili/view_history?uid=" + uid);
		setItems(res.data.items || []);
	};

	// 1. 点击 Search 按钮时获取收藏夹列表，并自动加载第一项
	const handleSearch = () => {
		if (!uid) return;
		setFavList({ name: "历史记录", id: "history" });
		// 设置选中的 key
		setSelectedKey(new Set([history]));
		// 立即拉取默认项的数据
		fetchItemsByFid();
	};

	// 2. 监听用户手动切换下拉框
	const handleSelectionChange = (keys, full) => {
		setSelectedKey(keys);
		const selectedId = Array.from(keys)[0];
		if (selectedId) {
			fetchItemsByFid(
				selectedId,
				itemsRef.current.filter(
					(item) => item.id + "" === selectedId,
				)[0].fid + "",
			);
		}
	};

	return (
		<div className="p-4">
			<div>
				<div className={"flex flex-row items-center"}>
					<Input
						label={"UID"}
						value={uid}
						onChange={(e) => setUid(e.currentTarget.value)}
						className={"max-w-xs"}
					/>
					<Button onClick={handleSearch} className={"ml-2"}>
						Search
					</Button>
				</div>

				{favList.length > 0 && (
					<Select
						label="选择收藏夹"
						className="max-w-xs mt-2"
						selectedKeys={selectedKey}
						onSelectionChange={(e) => handleSelectionChange(e)}
					>
						{favList.map((item) => (
							<SelectItem key={String(item.id)}>
								{item.name}
							</SelectItem>
						))}
					</Select>
				)}
			</div>

			<div className={"grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4"}>
				{items.map((item, index) => (
					<Card
						key={item.bv || index}
						className={"min-w-0 mt-1.5"}
						isHoverable
						isPressable
						onPress={() =>
							window.open(
								"https://www.bilibili.com/video/" + item.bv,
							)
						}
					>
						<CardBody>
							<div
								className={"flex flex-row items-center min-w-0"}
							>
								<Avatar src={`${AVATAR_API}${item.uid}`} />
								<div className={"ml-2 min-w-0 flex-1"}>
									<div
										className={"flex flex-row items-center"}
									>
										<p className={"truncate"}>
											{item.u_name}
										</p>
										{item.view_at && (
											<p className={"ml-4 text-small"}>
												{new Date(
													item.view_at,
												).toLocaleString()}
											</p>
										)}
									</div>
									<p className={"mt-1 font-bold truncate"}>
										{item.title}
									</p>
								</div>
							</div>
							<img
								src={item.cover + "@.avif"}
								className={
									"aspect-video object-cover w-full rounded-lg mt-2"
								}
								alt={item.title}
							/>
						</CardBody>
					</Card>
				))}
			</div>
		</div>
	);
}

export default FavPage;
